<form class="row">
    <div class="col-md-6">
        <div class="form-group">
            <label class="label font-sb mb-1">Category<span style="color: red;">*</span></label>
            <ng-select #ngCategory
                [items]="companyCategoryService.Categories$ | async" 
                bindLabel="categoryName" 
                bindValue="categoryName" 
                [formControl]="categoryControl"
                (change)="onCategoryChange($event)"
                [placeholder]="placeholder"
                >
            </ng-select>
            <app-form-errors [control]="categoryControl" fieldName="Category"></app-form-errors>
            
        </div>
    </div>
    <div class="col-md-6">
        <div class="form-group">
            <label class="label font-sb mb-1">Sub Category<span style="color: red;">*</span></label>
            <ng-select #ngSubCategory
                [items]="companyCategoryService.SubCategories$ | async" 
                bindLabel="subCategoryName" 
                bindValue="subCategoryName" 
                [formControl]="subCategoryControl"
                (change)="onSubCategoryChange($event)"
                [placeholder]="placeholder"
                >
            </ng-select>
            <app-form-errors [control]="subCategoryControl" fieldName="Sub Category"></app-form-errors>
        </div>
    </div>
</form>
